import {
  defineSchema,
  type SchemaFields,
  type SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";
import { objectEntries } from "@redotech/util/object";

export const recognizeSchema = defineSchema({
  fields: {
    isVip: {
      dataType: "Boolean",
      label: "VIP",
      documentation: "Whether the customer matched at least one VIP criterion.",
    },
    homeValue: {
      dataType: "Boolean",
      label: "High-value homeowner",
      documentation: "Whether the customer owns a high-value home.",
    },
    maxPlatformFollowers: {
      dataType: "Boolean",
      label: "Influencer",
      documentation:
        "Whether the customer is an influencer on a social platform.",
    },
    investorOrWealthManager: {
      dataType: "Boolean",
      label: "Investor or wealth manager",
      documentation:
        "Whether the customer invests or manages money professionally.",
    },
  } satisfies Record<
    "isVip" | "homeValue" | "maxPlatformFollowers" | "investorOrWealthManager",
    SchemaFields[string]
  >,
});

export const recognizeConditionFields = objectEntries(
  recognizeSchema.fields,
).map(([field]) => field);

export type RecognizeConditionField = keyof typeof recognizeSchema.fields;

export const exampleRecognizeInstance: SchemaInstance<typeof recognizeSchema> =
  {
    isVip: true,
    homeValue: false,
    maxPlatformFollowers: false,
    investorOrWealthManager: true,
  };
